import { useSyncImagesMutation } from '@/lib/graphql/generated/graphql';

export const useSyncImages = (dealId: string) => {
  const [syncImagesMutation, { loading, error }] = useSyncImagesMutation();

  const syncImages = async (dealItemsIds: string[]) => {
    return syncImagesMutation({
      variables: { dealId, dealItemsIds },
    });
  };

  return {
    syncImages,
    loading,
    error,
  };
};
